import { render } from "./FileContainer.vue?vue&type=template&id=65af286d"
import script from "./FileContainer.vue?vue&type=script&lang=js"
export * from "./FileContainer.vue?vue&type=script&lang=js"

import exportComponent from "D:\\PHPStormProjects\\hqam-customer-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__